import React, { useRef } from "react";
import "./SixthSection.css";
import { useScrollReveal } from "../../../custom-hooks/useScrollReveal";

export const SixthSection = ({ img, containerStyle, imgStyles }: any) => {
  const sectionRef = useRef<HTMLDivElement>(null);

  useScrollReveal(sectionRef, {
    selectorList: [".reveal-item"],
    maxBlur: 8,
    gapFactor: 2,
  });
  return (
    <div
      className={`sixth-section-container`}
      style={containerStyle ? containerStyle : {}}
      ref={sectionRef}
    >
      <img
        src={img}
        alt="Sixth section"
        className="sixth-section-image reveal-item test"
        style={imgStyles ? imgStyles : {}}
      />
    </div>
  );
};
